//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';


//Material-ui
import Button from '@material-ui/core/Button';
//Dialog
import DialogConfirm from './DialogConfirm';
//Part
import PartPageTitle from './PartPageTitle';


class Comp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitOnConfirm: false,
      submitOffConfirm: false,
      token: '',
      tokenError: null,
      tokenValid: false,
    }
  }

  componentDidMount() {
    document.title = '2段階認証の設定 - パートナーズ';
  }


  _tokenEdit(value) {
    var token = value.replace(/[ 　]/g, '');
    this.setState({ token: token});

    let errorComment;

    if (token.match(/^[0-9]+$/) == null) {
  		errorComment = '数字を入力してください';
  	}
    else if (token.length < 4 || token.length > 4) {
  		errorComment = '4桁の数字を入力してください';
  	}

  	if (errorComment) {
  		this.setState({tokenError: errorComment});
  	}
  	else {
      this.setState({tokenError: null});
    }
  }

  _tokenGet() {
    this.props.settingTwoFactorAuthTokenGet(
      () => this.setState({submitOnConfirm :true})
    )
  }

  _submitOn() {
    this.props.settingTwoFactorAuthEdit('submitOn', this.state.token, () => {
      this.setState({submitOnConfirm :false});
    });
  }

  _submitOff() {
    this.props.settingTwoFactorAuthEdit('submitOff', null, () => {
      this.setState({submitOffConfirm :false});
    });
  }

  render() {
    let content;
    if (this.state.submitOnConfirm === true) {
      content = (
        <div style={{padding:'15px'}}>
          <div style={{maxWidth:'400px', margin:'auto'}}>
            {this.props.my.setting.email}のメールアドレスに認証コードを送りました。本文に記載されている４桁の数字を入力してください。
          </div>
          <div align='center' style={{padding:'5px'}}>
            <input
              type="text"
              value={ this.state.token }
              style={{fontSize:'1.2em', width:'120px'}}
              className="input_blue round12"
              onChange={ (e) => this._tokenEdit(e.target.value) }
            />
          </div>
          <div align='center' style={{color:'red'}}>
            { this.state.tokenError }
          </div>
          <div align='center' style={{padding:'5px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'240px'}}
              onClick={ () => this._submitOn() }
              disabled={ (this.state.token.match(/^([0-9]{4})+$/) === null) ? true: false }
            >
              <div style={{fontSize:'1.2em'}}>有効にする</div>
            </Button>
          </div>

          <div>
            <Button
              variant="outlined"
              onClick={ () => this.setState({submitOnConfirm :false}) }
            >
              戻る
            </Button>
          </div>
        </div>
      )
    }
    else {
      content = (
        <div>
          <h3 align='center' style={{padding:'10px'}}>
            2段階認証とは?
          </h3>
          <div style={{maxWidth:'400px', margin:'auto'}}>
            不正ログインからアカウントを守る機能です。<br />ログインする際にメールアドレスに、４桁の数字の認証コードが送信されます。<br />認証コードをログイン画面に入力するとログインできるようになります。
          </div>

          {
            (this.props.my.setting.email) ? (
              <div style={{margin:'15px'}}>
                <h3 align='center' style={{padding:'10px'}}>
                  認証コードを送るメールアドレス
                </h3>
                <h4 align='center'>
                  {(this.props.my.setting.email) ? this.props.my.setting.email : '未設定'}
                </h4>
                <div align='center'>
                  <Button
                    variant="outlined"
                    onClick={ () => this.props.history.push('/setting/email/') }
                  >
                    メールアドレスの変更はこちら
                  </Button>
                </div>

                {
                  (this.props.my.setting.twoFactorAuthentication === 1) ? (
                    <div align='center' style={{padding:'15px'}}>
                      <Button
                        variant="outlined"
                        onClick={ () => this.setState({submitOffConfirm: true}) }
                      >
                        2段階認証を無効にする
                      </Button>
                    </div>
                  ):(
                    <div style={{padding:'15px'}}>
                      <div align='center' >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={ () => this._tokenGet() }
                          style={{fontSize:'1.2em'}}
                        >
                          2段階認証を有効にする
                        </Button>
                      </div>
                      <div style={{maxWidth:'400px', margin:'auto'}}>
                        <div style={{padding:'10px', color:'#666'}}>
                          メールアドレスの有効確認の為、認証コードが送信されます。<br />次の画面で認証コードを入力いただくと2段階認証は有効になります。
                        </div>
                      </div>
                    </div>
                  )
                }

              </div>

            ): (
              <div>
                <div align='center'>
                  <div style={{padding:'10px', color:'red'}}>
                    2段階認証を有効にするにはメールアドレスの登録が必要です。
                  </div>

                  <Button
                    variant="outlined"
                    onClick={ () => this.props.history.push('/setting/email/') }
                  >
                    メールアドレスの登録はこちら
                  </Button>
                </div>
              </div>
            )
          }
        </div>
      )
    }

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'2段階認証'}
          onback={ '/setting/' }
        />


        {
          content
        }
        <DialogConfirm
          open={ (this.state.submitOffConfirm) ? true : false }
          title={'2段階認証'}
          content={(<div>無効にするとアカウントが不正アクセスされるリスクが高まります。<br />それでも2段階認証を無効にしますか？</div>)}
          apply={ () => this._submitOff() }
          close={ () => this.setState({submitOffConfirm: false}) }
        />
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
